import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import { IRefreshFavDoc, NodeData } from '../models/kms-common.models';
import { SelectedPost } from 'src/app/digigov/models/switchPost.model';

@Injectable({
  providedIn: 'root',
})
export class KnowledgeManagementService {
  loggedInUserPostDetails$: Observable<SelectedPost> = this.authService
    .loggedInUserPost$;

  loggedInUserDetails$ = this.authService.loggedInUserSubject;
  refreshFavDocSubject = new Subject<IRefreshFavDoc>();
  private message = new BehaviorSubject('false');
  getmessage = this.message.asObservable();
  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private router: Router
  ) {}
  setmessage(msg) {
    this.message.next(msg);
    console.log(msg);
  }
  getFolderData(previlageId: number): Observable<NodeData[]> {
    return this.http.get<NodeData[]>(`/kms/folder-list/${previlageId}`).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }

  // FOR ALL DOC USE PRIVID 0
  //DOCUMENTS RELATED APIS
  getDocumentList(dataForPost: { privId: number }): Observable<any> {
    return this.http.post(`/kms/all-doc-dtls`, dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
  allDocsData(dataForPost): Observable<any> {
    return this.http.post(`/kms/all-doc-dtls`, dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
  onboarding(dataForPost): Observable<any> {
    return this.http.post(`/kms/user-onboarding`, dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
  addDocInCase(dataForPost): Observable<any> {
    return this.http.post(`/case-mgmnt/add-ref-docs`, dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
  removeDocInCase(dataForPost): Observable<any> {
    return this.http
      .put(`/case-mgmnt/remove-ref-doc-in-case`, dataForPost)
      .pipe(
        map((response: any) => response?.data),
        catchError((error) => throwError(error))
      );
  }
  getDocInCase(dataForPost): Observable<any> {
    return this.http.post('/case-mgmnt/ref-docs-in-case', dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => {
        throw error;
      })
    );
  }
  getDocInCaseForCase(dataForPost): Observable<any> {
    return this.http.post('/case-mgmnt/ref-docs-in-case', dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => {
        throw error;
      })
    );
  }
  createNewDocument(res: any) {
    return this.http.post('/kms/ref-doc', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  // kms/version-document
  updateNewDocument(res: any) {
    return this.http.post('/kms/version-document', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  getDocumentData(docId: number | string) {
    return this.http.get(`/kms/doc-dtls?docId=${docId}`).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }

  getPreviewData(mpgId: number | string) {
    return this.http.get(`/dms/file-content?mpgId=${mpgId}`).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }

  downloadDocument(mpgId: number) {
    let params = new HttpParams().set('mpgId', mpgId);
    return this.http.get('/dms/file-content', { params: params }).pipe(
      map((response: any) => response?.data),
      tap((res) => {
        let byteCharacters = atob(res.fileBytes);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);

        let filename = res.docFileName;
        let binaryData = [];
        binaryData.push(byteArray);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'blob' })
        );
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
      }),
      catchError((error) => throwError(error))
    );
  }

  //FAVOURITE DOCUMENTS RELATED APIS
  getFavouriteDocList(res: any, isGrid = false) {
    return this.http.post('/kms/all-fav-doc', res).pipe(
      map((response: any) => (isGrid ? response?.data : response?.data?.rows)),

      catchError((error) => throwError(error))
    );
  }

  addFavDoc(dataForPost: { refDocID: number[] }) {
    return this.http.post('/kms/fav-doc', dataForPost).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }

  deleteFavDoc(res: any) {
    return this.http.put('/kms/fav-doc', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }

  //FOLDER RELATED APIS
  createFolder(res: any) {
    return this.http.post('/kms/folder', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  createBulkFolderGrid() {
    return this.http.post('/kms/create-folder-grid', {}).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  updateFolder(res: any) {
    return this.http.put('/kms/folder', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  moveFolder(res: any) {
    return this.http.post('/kms/move-folder', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }

  getFolderDesc(res: number) {
    return this.http.get(`/kms/folder?privId=${res}`).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }

  deleteFolder(res: any) {
    return this.http.put('/kms/folder/remove', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  subscribeFolder(res: any) {
    return this.http.post('/kms/folder-subscription', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  unsubscribeFolder(res: any) {
    return this.http.put('/kms/folder-subscription', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }

  //ACCESS
  getFolderStakeholders(privId: number): Observable<any> {
    const dataForPost = {
      privId: privId,
    };
    return this.http.post('/kms/all-folder-rights', dataForPost).pipe(
      map((response: any) => JSON.parse(response?.data)),
      catchError((error) => throwError(error))
    );
  }
  getRight(privId: number): Observable<any> {
    let params = new HttpParams().set('privId', privId);
    return this.http.get('/kms/access-rights', { params: params }).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
  addAccessRights(dataForPost: {
    privId: number;
    roleId: number;
    roleFlag: number;
    aclId: number;
    strEndDate: string;
  }): Observable<any> {
    return this.http.post('/kms/folder-rights', dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
  updateAccessRights(dataForPost: {
    privId: number;
    roleId: number;
    roleFlag: number;
    aclId: number;
    rlGrpPk: number;
    strEndDate: string;
  }): Observable<any> {
    return this.http.put('/kms/change-folder-rights', dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
  revokeFolderAccess(dataForPost: {
    privId: number;

    rlGrpPk: number;
  }): Observable<any> {
    return this.http
      .put('/kms/folder-rights', dataForPost)
      .pipe(catchError((error) => throwError(error)));
  }

  //COMMON CORE APIS
  processConfigGetProcessList(): Observable<any> {
    return this.http.post('/admin/get-process-details', null).pipe(
      map((response: any) => response?.data),
      catchError((error) => {
        throw error;
        this.router.navigateByUrl('main/reference-docs');
      })
    );
  }

  getComboData(comboId: number | String, extraParams?) {
    let dataForPost = {
      ComboId: comboId.toString(),
    };
    if (extraParams) {
      dataForPost = { ...dataForPost, ...extraParams };
    }

    return this.http.post('/worklist/get-combo-list', dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
  getEmployeeSearchDetails(empId: number | string): Observable<any> {
    return this.http.get(`/admin/employee-details/${empId}`).pipe(
      map((response: any) => response?.data),
      catchError((error) => {
        throw error;
      })
    );
  }

  getOrgSearchDetails(orgId: number | string): Observable<any> {
    let params = new HttpParams().set('orgId', orgId);

    return this.http
      .get('/admin/organization-search-details', { params: params })
      .pipe(
        map((response: any) => response?.data),
        catchError((error) => {
          throw error;
        })
      );
  }
  getAuditByDocument(docId: number): Observable<any> {
    const dataForPost = {
      refDocId: docId,
    };
    return this.http.post(`/kms/get-doc-audit-dtls`, dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => {
        throw error;
      })
    );
  }
  getAuditByFolder(folderId: number): Observable<any> {
    const dataForPost = {
      privId: folderId,
    };
    return this.http.post('/kms/get-doc-audit-dtls', dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => {
        throw error;
      })
    );
  }
  getBreadcrumbData(folderId: number): Observable<any> {
    return this.http.get<any>(`/kms/prnt-priv-list/${folderId}`).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
}
